import { PayloadAction } from "@reduxjs/toolkit";
import {
  InitialState,
  BreadcrumbValue
} from "./Types";

export const Reducer = {
  /**
   * Set the breadcrumb item
   * @param state initial state
   * @param action payload
   */
  setBreadcrumbItem: (state: InitialState, action: PayloadAction<BreadcrumbValue>): void => {
    state.clickedItem = action.payload;
  },
  /**
   * Update the breadcrumb item
   * @param state initial state
   * @param action payload
   */
  updateItemView: (state: InitialState, action: PayloadAction<BreadcrumbValue>): void => {
    state.breadcrumbSelectedItem = action.payload;
  },
};
